import React from "react";
import { useGetUserProfileQuery } from "../../../rtk-query/slices/profile/profileSlice";
import VPSupplierType from "./VPSupplierType";
import VPPersonalDetails from "./VPPersonalDetails";
import VPBusinessDetails from "./VPBusinessDetails";
import VPExperienceOffered from "./VPExperienceOffered";

import EditIcon from "../../../assets/vp-edit-profile-icon.png";
import { Link } from "react-router-dom";
import { Icon } from "@iconify/react/dist/iconify.js";
import VPAccountDetails from "./VPAccountDetails";

function ViewProfileMainWrapper() {
  const { data: userInfo } = useGetUserProfileQuery();

  return (
    <div className="dod-product-listing-main-wrapper">
      {/* title and create product button */}
      <div className="w-100 mb-3 d-flex flex-sm-row flex-column align-items-center justify-content-sm-between justify-content-center gap-sm-0 gap-3">
        <h2 className="ob-supplier-content-heading">Edit Profile</h2>
        <Link
          to={"/edit-profile"}
          className="vp-edit-profile-btn d-flex align-items-center gap-2"
        >
          <img src={EditIcon} alt="Edit Icon" width={23} height={23} /> Edit
          Profile
        </Link>
      </div>

      <div className="d-flex align-items-center mb-4 gap-3">
        <img
          src={userInfo?.data?.supplier?.supplier_company_logo}
          alt="Profile"
          className="vp-profile-img"
          width={90}
          height={90}
        />
        <div className="d-flex flex-column gap-0">
          <h1 className="m-0 pb-1 vp-supplier-type-title">Oasis palm</h1>
          <p className="m-0 p-0">
            <Icon icon="tabler:at" className="me-2" />
            {userInfo?.data?.supplier_user_email}
          </p>
          <p className="m-0 p-0">
            <Icon icon={"uil:link"} className="me-2" />
            {userInfo?.data?.supplier?.supplier_website}
          </p>
        </div>
      </div>

      {/* Layout with sidebar and content */}
      <div className="row">
        {/* Left Column */}
        <div className="col-lg-6 ps-0 pe-lg-2 pe-0">
          <VPSupplierType userInfo={userInfo} />
          <VPPersonalDetails userInfo={userInfo} />
        </div>

        {/* Right Column  */}
        <div className="col-lg-6 pe-0 ps-lg-2 ps-0">
          <VPBusinessDetails userInfo={userInfo} />
          <VPExperienceOffered userInfo={userInfo?.data} />
          <VPAccountDetails userInfo={userInfo} />
        </div>
      </div>
    </div>
  );
}

export default ViewProfileMainWrapper;
